<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Claim Batches
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-billing-filter (searchEvent)="onSearch($event)" [filterFields]="fields"></ppl-billing-filter>
                </div>
                <div class="table-style">
                    @if(batches.length > 0) {
                    <ppl-list-table [disableSearch]="true" [showCustomSearch]="false" [enableActions]="false"
                        [data]="batches" (rowDetailEvent)="rowClicked($event)" (rowDetailEventTs)="rowClickedTs($event)"
                        [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="true"
                        [loadPage]="true" [customDataLoaded]="true" (onPageLoad)="onPageLoad($event)"
                        [from]="'billing'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="filter-panel">
    <ng-template #timesheetDialog let-cancel="cancel">
        <ppl-ignored-timesheets style="padding-top: 12px" [ignoredTimesheetData]="ignoredTimesheetData"
            [ignoredTimesheetSummaryData]="ignoredTimesheetSummaryData"
            [selectedBatchId]="selectedBatchId"></ppl-ignored-timesheets>
    </ng-template>
</div>